import { useCallback, useMemo } from 'react';

import type { CHART_METRIC } from '@/entities/chart/model/constants';

import {
  getChartMetricLabel,
  getChartMetricPolicy,
} from './helper';

export const useChartMetricPolicy = () => {
  const policy = useMemo(() => getChartMetricPolicy(), []);

  const metricOptions = useMemo(
    () =>
      policy.metrics.map((metric) => ({
        value: metric,
        label: getChartMetricLabel(metric),
      })),
    [policy],
  );

  const getSafeMetric = useCallback(
    (metric: CHART_METRIC | undefined) =>
      metric && policy.metrics.includes(metric) ? metric : policy.fallbackMetric,
    [policy],
  );

  const isMetricAllowed = useCallback(
    (metric: CHART_METRIC | undefined) =>
      !!metric && policy.metrics.includes(metric),
    [policy],
  );

  const getMetricLabel = useCallback(
    (metric: CHART_METRIC | undefined) =>
      getChartMetricLabel(getSafeMetric(metric)),
    [getSafeMetric],
  );

  return {
    comboSecondary: policy.comboSecondary,
    fallbackMetric: policy.fallbackMetric,
    policy,
    metricOptions,
    getMetricLabel,
    getSafeMetric,
    isMetricAllowed,
  };
};
